import { connect } from 'react-redux';
import DeleteHazardReviewDialog from '../../components/DeleteHazardReviewDialog';
import { submitMode } from '../../constants';

import {
  openDeleteHazardReviewDialogDispatch,
  submitHazardReviewDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    review: state.hazard.toBeDeleteReview.item,
    open: state.hazard.toBeDeleteReview.showDeleteHazardReviewDialog,
    isSaving: state.hazard.toBeDeleteReview.isSaving,
    errorMessage: state.hazard.newReview.errorMessage
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showDialog: (open, reviewId) => {
      dispatch(openDeleteHazardReviewDialogDispatch(open, reviewId));
    },
    onConfirmHazardReviewDelete: (payload) => {
      const mode = submitMode.UPDATE;
      dispatch(submitHazardReviewDispatch(payload, mode));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteHazardReviewDialog);
